const featured_videos: any[] = [
    "media/projects/hotel-rural-belas/video.mp4",
    "media/projects/palacete-estoril/video.mp4",
];

export default featured_videos;
